import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { initDeductionsSaga } from '../sagas/initDeductionsSaga';
import { submitDeductionsSaga } from '../sagas/submitDeductionsSaga';

export function* NDFL3LightHealingDeductionsSaga() {
  yield takeEvery(actionTypes.INITIALIZE, initDeductionsSaga);
  yield takeEvery(actionTypes.SUBMIT, submitDeductionsSaga);
}
